export const ELLIPSIS = '...';

export const PAGINATION_VARIANTS = {
  default: 'default',
  secondary: 'secondary',
  reduced: 'reduced',
  minimal: 'minimal',
};

export const PAGINATION_BUTTON_LABEL_PREV = 'Previous';
export const PAGINATION_BUTTON_LABEL_NEXT = 'Next';
export const PAGINATION_BUTTON_LABEL_PAGE = 'Page';
export const PAGINATION_BUTTON_LABEL_CURRENT_PAGE = 'Current Page';
export const PAGINATION_BUTTON_LABEL_PAGE_OF_COUNT = 'of';
export const PAGINATION_BUTTON_ICON_BUTTON_NEXT_ALT = 'Go to next page';
export const PAGINATION_BUTTON_ICON_BUTTON_PREV_ALT = 'Go to previous page';
